import { Image } from '@bw/elements';
import { FC } from 'react';

import styles from './brightway-by-the-numbers.module.scss';
import { Counter } from './counter';

const PROPS = {
	heading: 'Brightway by the numbers',
	numberCards: [
		{ value: null, heading: '$ 1 Billion+', description: 'Annualized Premium' },
		{ value: 500000, heading: '500,000+', description: 'Policies Sold' },
		{ value: 350, heading: '350+', description: 'Offices Across the Country' },
	],
	image: {
		url: 'https://images.ctfassets.net/bn78uo9dn8bo/5sPhVRjNHa2BDzoV2DK4SL/ddf2aa3ae040384792074f4ccfffabf3/icon-logo.svg',
		width: 53,
		height: 42,
		alt: '',
	},
};

export const BrightwayByTheNumers: FC = () => {
	return (
		<section className={styles['WithNumberCard']}>
			<div className="container">
				<div className="WithNumberCard__row" data-aos="fade-up">
					<div
						className="WithNumberCard__col-title"
						data-aos="fade-up"
						data-aos-delay="100"
					>
						<h3 data-aos="fade-up" data-aos-delay="150">
							{PROPS.heading}
						</h3>
						<figure>
							<Image
								src={PROPS.image.url}
								width={PROPS.image.width}
								height={PROPS.image.height}
								alt={PROPS.image.alt}
							/>
						</figure>
					</div>
					<div
						className="WithNumberCard__col-number"
						data-aos="fade-up"
						data-aos-delay="200"
					>
						{PROPS.numberCards.map((card, index) => (
							<div key={index} data-aos="fade-up">
								<span className="countUpContainer">
									{card.value ? (
										<>
											<Counter end={Number(card.value)} />+
										</>
									) : (
										card.heading
									)}
								</span>
								<p>{card.description}</p>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};
